export default {
  init() {
    $(".single-post-content > .wp-block-group__inner-container > *")
      .not(".is-style-related-articles")
      .wrapAll("<div class='single-post-inner-content'></div>");

    $(".block.share")
      .clone()
      .addClass("share--bottom")
      .appendTo(".single-post-inner-content");

    //Move video in header if is the first block
    if ($(".post-meta").next(".wp-block-video").length) {
      $(".post-header-image img").remove();
      $(".post-meta")
        .next(".wp-block-video")
        .appendTo($(".post-header-image"));
    }

    window.Sharer.init();
  },
};
